import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ThemeProvider, useTheme } from "./context/ThemeContext";
import Login from "./pages/Login";
import ChatPage from "./pages/ChatPage";
import Library from "./pages/Library";
import CanvaPage from "./pages/CanvaPage";
import MemoryPage from "./pages/MemoryPage";
import Admin from "./pages/Admin";
import Upscaler from "./pages/Upscaler";

function Protected({ children, adminOnly }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="h-screen bg-[var(--bg)] flex items-center justify-center">
        <span className="text-[var(--text-2)] text-sm animate-pulse">Loading your workspace…</span>
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function Shell() {
  const { theme } = useTheme();
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><ChatPage /></Protected>} />
          <Route path="/library" element={<Protected><Library /></Protected>} />
          <Route path="/canva" element={<Protected><CanvaPage /></Protected>} />
          <Route path="/memory" element={<Protected><MemoryPage /></Protected>} />
          <Route path="/upscaler" element={<Protected><Upscaler /></Protected>} />
          <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
        </Routes>
      </BrowserRouter>
      <Toaster theme={theme} position="top-right" toastOptions={{ style: { background: "var(--surface)", border: "1px solid var(--border-strong)", color: "var(--text)", borderRadius: "14px", fontFamily: "Albert Sans, sans-serif" } }} />
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Shell />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
